/**
 * Latest owners registry (Aksjonærregisteret) update year
 */
export const LATEST_OWNERSHIP_REGISTRY_RECORD_YEAR = 2024;

// hard code owners registry date to be the end of LATEST_OWNERSHIP_REGISTRY_RECORD_YEAR
export const LATEST_OWNERSHIP_REGISTRY_DATE = new Date(LATEST_OWNERSHIP_REGISTRY_RECORD_YEAR, 11, 31);
